var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',[(!_vm.firstLoader)?_c('FormBuilder',{attrs:{"form":_vm.form,"schemaJson":_vm.schemaJson,"v":_vm.$v}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }